import React from 'react';
import AdminListGroup from '../../../components/admin/AdminListGroup';
import { InvestorProjectModelDetail } from '../models/investors';
import useAuth from '../../../hooks/useAuth';

export type Props = {
  model: InvestorProjectModelDetail;
  projectId: string;
};
const InvestorProjectModelActions: React.FC<Props> = ({ model, projectId }) => {
  const { isPermissionAvailable } = useAuth();
  const fieldMapper = [
    {
      title: (
        <>
          <i className="ni ni-ruler-pencil mr-2" /> Editar modelo
        </>
      ),
      value: '',
      href: `/investors/projects/${projectId}/models/${model.id}/edit`,
    },
    {
      title: (
        <>
          <i className="fa fa-solid fa-plus mr-2" /> Agregar nueva unidad al
          modelo
        </>
      ),
      value: '',
      href: `/investors/models/${model.id}/model-units/create`,
    },
    {
      title: (
        <>
          <i className="fa fa-duotone fa-plus mr-2" /> Agregar unidades con CSV
        </>
      ),
      value: '',
      href: `/investors/models/${model.id}/create-units-in-csv`,
    },
    {
      title: (
        <>
          <i className="fa fa-duotone fa-pencil mr-2" /> Editar unidades con CSV
        </>
      ),
      value: '',
      href: `/investors/models/${model.id}/edit-units-in-csv`,
    },
    {
      title: (
        <>
          <i className="fa fa-duotone fa-building mr-2" /> Administrar unidades
          del modelo
        </>
      ),
      value: '',
      href: `/investors/models/${model.id}/model-units`,
    },
    {
      title: (
        <>
          <i className="fa fa-duotone fa-image mr-2" /> Agregar imágenes al
          modelo
        </>
      ),
      value: '',
      href: `/investors/projects/${projectId}/models/${model.id}/upload-images`,
    },
  ];
  if (isPermissionAvailable('SHOW_MARKETPLACE_SYNC')) {
    fieldMapper.push({
      title: (
        <>
          <i className="fa fa-sync mr-2"></i> Sincronizar con marketplace
        </>
      ),
      value: '',
      href: `/sync-marketplace/${model.id}/model`,
    });
  }
  return <AdminListGroup title={'Administrar modelo'} items={fieldMapper} />;
};

export default InvestorProjectModelActions;
